/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { getAxios } from '@dataplace.ai/functions/utils'
import { ENDPOINTS } from '../../constants/endpoints'

export default class Geocoder {
  async reverseGeocode(lat: number, lng: number) {
    const axiosInstance = await getAxios({
      modifyRequestResponseCase: false,
    })
    const res = await axiosInstance.post(ENDPOINTS.GEOCODER, {
      lat: `${lat}`,
      lng: `${lng}`,
    })

    if (!res?.data?.length) {
      return undefined
    }

    return res.data
  }
}
